module.exports = __webpack_public_path__ + "img/icon_arrow_left_12@2x.6fbf312c.png";